import styled from 'styled-components';

const FormSection = styled.div`
  width: 100%;
  flex-basis: 100%;
  margin-bottom: 12px;
`;

export default FormSection;
